export const CREATIVE_DRAFT_AUTOSAVE_MS = 500

interface FormatCreativeDraftTitleArgs {
  letter: string
  headline: string
  setSize: number
  t: (key: string, options?: Record<string, string>) => string
}

export function formatCreativeDraftTitle(
  args: FormatCreativeDraftTitleArgs,
): string {
  const { letter, headline, setSize, t } = args

  if (setSize <= 1) {
    return t('threads.detail.creativeDraft.titledSingle', { headline })
  }

  return t('threads.detail.creativeDraft.titledSet', { letter, headline })
}

export function creativeDraftCardTestId(letter: string): string {
  return `thread-creative-draft-card-${letter.toLowerCase()}`
}

export function isCreativeDraftConfirmed(draft: {
  confirmedAt?: string | null
  publicId?: string | null
}): boolean {
  return Boolean(draft.confirmedAt || draft.publicId)
}
